function normalize (str) {
  return str
          .replace(/[\/]+/g, '/')
          .replace(/\/\?/g, '?')
          .replace(/\/\#/g, '#')
          .replace(/\:\//g, '://');
}

module.exports = function () {
  var joined = [].slice.call(arguments, 0).join('/');
  return normalize(joined);
};


//////////////////
// WEBPACK FOOTER
// ./~/url-join/lib/url-join.js
// module id = 56
// module chunks = 0 1